import angular from 'angular';

import AccessRulesService from './accessRulesService.js';

angular.module('sh.accessRules', []).factory('AccessRulesService', AccessRulesService);
